import {
  GLOBAL_SCOPE_ID,
  getCountryName,
  getRegionsForScope,
  isBroadScope,
} from "@legal-500/discovery/data";

export type ScopeOption = { id: string; label: string };

/**
 * Resolves a single firm-entitled scope id (global sentinel, entitlement-region id, or
 * numeric country/site-structure id) to a human-readable label, e.g. "EMEA" -> "Europe, Middle
 * East & Africa", "107098" -> "France". Falls back to the raw id when discovery has no match.
 *
 * GLOBAL_SCOPE_ID must NOT be labelled "Worldwide" — "Worldwide" is a distinct country/region
 * peer entity (site_structure id 5693884), unrelated to the all-regions global sentinel.
 */
export function resolveScopeLabel(scopeId: string): string {
  if (scopeId === GLOBAL_SCOPE_ID) return "Global (all regions)";
  if (isBroadScope(scopeId)) {
    const matchedRegion = getRegionsForScope([scopeId]).find(
      region => region.entitlementScopeId === scopeId,
    );
    if (matchedRegion) return matchedRegion.name;
  }
  return getCountryName(scopeId) ?? scopeId;
}

export function buildScopeOptions(scopeIds: string[]): ScopeOption[] {
  return scopeIds.map(scopeId => ({ id: scopeId, label: resolveScopeLabel(scopeId) }));
}
